import {
  LearnerPretestStatus,
  PretestOutcome,
  TrainingInitQuery
} from '~/data';
import { Pretest } from './PretestSlice';

// Every operation selects the same pretest fields, so this type fits them all.
type ApiPretest = TrainingInitQuery['learnerTraining']['pretest'];

export const toPretest = (pretest: ApiPretest): Pretest | null =>
  pretest
    ? {
        status: pretest.status,
        testableChapterCount: pretest.testableChapterCount,
        questionCount: pretest.questionCount,
        fullCourseEligible: pretest.fullCourseEligible,
        completedCourse: pretest.completedCourse,
        skipRule: pretest.skipRule,
        passingScorePercent: pretest.passingScorePercent ?? null,
        scorePercent: pretest.scorePercent ?? null,
        correctCount: pretest.correctCount ?? null,
        passed: pretest.passed ?? null,
        results: pretest.results.map(
          ({ chapterId, outcome, asked, correct }) => ({
            chapterId,
            outcome,
            asked,
            correct
          })
        )
      }
    : null;

/** The learner still has the pretest ahead of them: not taken, or not finished. */
export const isPretestOffered = (pretest: Pretest | null) =>
  pretest?.status === LearnerPretestStatus.Available ||
  pretest?.status === LearnerPretestStatus.InProgress;

/**
 * Chapters the learner answered fully right. The server also reports these as
 * Chapter.testedOut; after a mutation the player reads them from the pretest it
 * returns rather than reloading every chapter.
 */
export const pretestTestedOutChapterIds = (pretest: Pretest | null) =>
  pretest?.status === LearnerPretestStatus.Completed
    ? pretest.results
        .filter(result => result.outcome === PretestOutcome.TestedOut)
        .map(result => result.chapterId)
    : [];
